<template>
  <div class="my-account bg-grey h-100">
    <NavbarMain />
    <div class="row m-0 my-3 h-auto">
      <NavbarAccount class="h-100 col-xl-auto col-md-12 col-12" />
      <div class="col-xl col-md-12 px-0">
        <div class="bg-white p-1 p-md-5 shadow-sm container-xl">
          <div class="row m-0">
            <div class="col-md-4 col-6 text-left">
              <h4 class="mb-5">Mi balance</h4>
            </div>
            <div class="col-md-4 col-6 text-center">
              <h4 class="mb-5">Saldo: SC${{ maxPayment.toFixed(2) }}</h4>
            </div>
            <div class="col-md-4 col-12" v-show="maxPayment > 0.01">
              <h4 class="text-right">
                <span
                  class="btn btn-treid my-1"
                  @click="showModalTransferPayment()"
                  :class="transactions.length && maxPayment > 0 ? '' : 'd-none'"
                  >Transferir saldo a Sistema Apple</span
                >
                <!-- <span
                  class="btn btn-treid ml-1 my-1"
                  @click="showModalRetirePayment()"
                  :class="transactions.length && maxPayment > 0 ? '' : 'd-none'"
                  >Retirar saldo a cuenta bancaria</span
                > -->
              </h4>
            </div>
          </div>

          <div :class="transactions.length ? '' : 'd-none'">
            <table class="table">
              <thead class="thead-dark">
                <tr>
                  <th>Fecha</th>
                  <th>Importe</th>
                  <th>Motivo</th>
                  <th>Estado</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="transaction in transactions" :key="transaction._id">
                  <td>{{ dateToFullString(transaction.creationDate) }}</td>
                  <td>
                    <b v-if="transaction.payment > 0"
                      >SC${{ transaction.payment.toFixed(2) }}</b
                    >
                    <b v-else>- SC${{ (-transaction.payment).toFixed(2) }}</b>
                  </td>
                  <td>
                    <span v-if="transaction.name == 'DEFAULT_SALE'"
                      >Venta de productos</span
                    >
                    <span
                      v-if="
                        transaction.name == 'APPLE_TRANSACTION' ||
                        transaction.name == 'DEFAULT_TRANSACTION'
                      "
                      >Transferencia a Sistema Apple</span
                    >
                    <span v-if="transaction.name == 'DEFAULT_RETIRE'"
                      >Retiro de saldo</span
                    >
                  </td>
                  <td
                    v-if="transaction.payment < 0"
                    class="d-flex align-items-center"
                  >
                    <span
                      v-if="transaction.state == 0 || !transaction.state"
                      class="material-icons text-warning"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="en proceso de retiro"
                    >
                      history
                    </span>
                    <span
                      v-if="transaction.state == 1"
                      class="material-icons text-success"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="retiro aceptado"
                    >
                      check_circle_outline
                    </span>
                    <span
                      v-if="transaction.state == 2"
                      class="material-icons text-danger"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="retiro denegado"
                    >
                      highlight_off
                    </span>

                    <span
                      class="d-none d-lg-block pl-1"
                      v-if="transaction.state == 0 || !transaction.state"
                      >En proceso de retiro</span
                    >
                    <span
                      class="d-none d-lg-block pl-1"
                      v-if="transaction.state == 1"
                      >{{
                        transaction.name == "APPLE_TRANSACTION"
                          ? "Transferencia aceptada"
                          : "Retiro aceptado"
                      }}</span
                    >
                    <span
                      class="d-none d-lg-block pl-1"
                      v-if="transaction.state == 2"
                      >Retiro denegado</span
                    >
                  </td>
                  <td class="text-center" v-else>-</td>
                  <td>
                    <span
                      class="material-icons"
                      :class="
                        transaction.name == 'DEFAULT_SALE'
                          ? 'text-success'
                          : 'text-danger'
                      "
                    >
                      {{
                        transaction.name == "DEFAULT_SALE"
                          ? "trending_up"
                          : "trending_down"
                      }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div :class="transactions.length ? 'd-none' : ''">
            <h5 class="text-center text-secondary">
              Aún no tienes transacciones realizadas.
            </h5>
          </div>
        </div>
      </div>
    </div>
    <ModalTransactionPayment
      v-on:close="closeModalPayment()"
      :visible="modalTransactionPayment.visible"
      :maxPayment="modalTransactionPayment.maxPayment"
      v-on:trasnfer="handleTrasnfer($event)"
    />
    <ModalNewTransaction
      :visible="modalNewTransaction.visible"
      :payment="modalNewTransaction.payment"
    />

    <ModalRetirePayment
      v-on:close="closeModalRetire()"
      :visible="modalTranserPayment.visible"
      :maxPayment="modalTranserPayment.maxPayment"
      v-on:trasnfer="handleRetire($event)"
    />
    <ModalNewRetire
      :visible="modalNewRetire.visible"
      :payment="modalNewRetire.payment"
      :metodo="modalNewRetire.metodo"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAccount from "@/components/account/NavbarAccount.vue";
import ModalTransactionPayment from "@/components/modals/ModalTransactionPayment.vue";
import ModalNewTransaction from "@/components/modals/ModalNewTransaction";
import ModalNewRetire from "@/components/modals/ModalNewRetire";
import ModalRetirePayment from "@/components/modals/ModalRetirePayment";
import Api from "../../tools/Api2";
export default {
  name: "MyBalance",
  components: {
    NavbarMain,
    NavbarAccount,
    ModalTransactionPayment,
    ModalRetirePayment,
    ModalNewTransaction,
    ModalNewRetire,
  },
  data() {
    return {
      transactions: [],
      maxPayment: 0,
      modalTransactionPayment: {
        visible: false,
        maxPayment: 0,
      },
      modalNewTransaction: {
        visible: false,
        payment: "0",
      },
      modalTranserPayment: {
        visible: false,
        maxPayment: 0,
      },
      modalNewRetire: {
        visible: false,
        payment: "0",
        metodo: "",
      },
    };
  },
  methods: {
    handleTrasnfer({payment, success}) {
      if (success) {
        this.modalNewTransaction.payment = payment;
        this.modalNewTransaction.visible = true;
      } else {
        alert("ups, hubo un problema en la operacion, intente mas tarde");
      }
    },

    handleRetire({ payment, metodo }) {
      this.modalNewRetire.payment = payment;
      this.modalNewRetire.visible = true;
      this.modalNewRetire.metodo = metodo;
    },
    showModalTransferPayment() {
      this.modalTransactionPayment.visible = true;
    },
    showModalRetirePayment() {
      this.modalTranserPayment.visible = true;
    },
    closeModalPayment() {
      this.modalTransactionPayment.visible = false;
    },
    closeModalRetire() {
      this.modalTranserPayment.visible = false;
    },
    dateToFullString(str) {
      let date = new Date(str);
      return `${date.getDate()}.${
        (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1)
      }.${date.getFullYear()} a las ${date.getHours()}:${
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
      }`;
    },
  },
  computed: {
    ...mapState(["auth"]),
  },
  created: async function () {
    Api("transaction")
      .get("my-transacctions")
      .then((res) => {
        this.transactions = res.transactions;
        this.modalTransactionPayment.maxPayment = res.transactions.reduce(
          (acc, e) => acc + e.payment,
          0
        );
        this.modalTranserPayment.maxPayment = res.transactions.reduce(
          (acc, e) => acc + e.payment,
          0
        );
        this.maxPayment = this.modalTransactionPayment.maxPayment;
      });
  },
};
</script>

<style lang="scss" scoped>
footer {
  position: absolute;
}

.text-secondary a {
  color: #172b46 !important;
  font-weight: bold;
}
</style>
